<template>
    <form method="POST"
          @submit="checkForm"
          action="/forms/contact">

        <input type="hidden" name="_token" v-bind:value="csrf">
        <input type="hidden" name="form-name" value="contact"/>

        <label for="name">Naam</label>
        <input
            type="text"
            id="name"
            name="name"
            placeholder="Jouw naam"
            v-model="name"
            @keyup="checkName"
            v-bind:class="{ error: hasNameError, valid: nameIsValid }">

        <label for="telephone">Telefoon</label>
        <input
            type="text"
            name="phone"
            id="telephone"
            placeholder="Mobiel of vast nummer"
            v-model="tel"
            @keyup="checkTel"
            v-bind:class="{ error: hasTelError, valid: telIsValid }">

        <label for="email">E-mail</label>
        <input
            type="email"
            id="email"
            name="email"
            placeholder="naam@voorbeeld.nl"
            v-model="email"
            @keyup="checkEmail"
            v-bind:class="{ error: hasEmailError, valid: emailIsValid }">

        <label for="question">Jouw vraag</label>
        <textarea
            id="question"
            name="subject"
            placeholder="Wat wil je vragen?"
            v-model="question"
            @keyup="checkQuestion"
            v-bind:class="{ error: hasQuestionError, valid: questionIsValid }"></textarea>

        <div class="checkbox">
            <input
                type="checkbox"
                id="nieuwsbrief"
                name="newsletter"
                v-model="newsletter">
            <label for="nieuwsbrief">
                Hou mij op de hoogte van de huizenmarkt en speciale aanbiedingen
            </label>
        </div>

        <div class="checkbox">
            <input
                type="checkbox"
                id="privacy"
                name="privacy"
                v-model="privacy"
                v-bind:class="{ error: hasPrivacyError, valid: privacyIsValid }"
                >
            <label for="privacy">
                Ik ga akkoord met de&nbsp;<a href="/privacyverklaring">privacyverklaring</a>
            </label>
        </div>

        <button type="submit" class="button">Verstuur mijn vraag</button>
    </form>

</template>

<script>
    export default {
        data() {
            return {
                message: '',
                hasMessageError: false,

                tel: '',
                hasTelError: false,
                telIsValid: false,

                email: '',
                hasEmailError: false,
                emailIsValid: false,

                name: '',
                hasNameError: false,
                nameIsValid: false,

                privacy: '',
                hasPrivacyError: false,
                privacyIsValid: false,

                newsletter: '',

                question: '',
                hasQuestionError: false,
                questionIsValid: false,
            }
        },

        props: ['csrf', 'oldName', 'error'],

        mounted() {
            if (this.error !== 'false') {
                const kaas = document.querySelector('input[name=' + this.error + ']');
                kaas.classList.add("error");
            }
        },

        methods: {

            checkName() {
                this.hasNameError = !this.name;
                this.nameIsValid = this.name;

                return false;
            },

            checkTel() {
                this.hasTelError = !this.validTel(this.tel);
                this.telIsValid = this.tel;
            },

            checkEmail() {
                this.hasEmailError = !this.validEmail(this.email);
                this.emailIsValid = this.email;
            },

            checkQuestion() {
                this.hasQuestionError = !this.question;
                this.questionIsValid = this.question;
            },

            checkPrivacy() {
                this.hasPrivacyError = !this.privacy;
                this.privacyIsValid = this.privacy;
            },

            checkForm(e) {

                this.checkName();
                this.checkTel();
                this.checkEmail();
                this.checkPrivacy();
                this.checkQuestion();

                if (this.privacyIsValid &&
                    this.emailIsValid &&
                    this.telIsValid &&
                    this.nameIsValid) {
                    return true;
                }

                e.preventDefault();
            },

            validEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                return re.test(email);
            },

            validTel(telephone) {
                let re = /^\d{10}$/;
                return re.test(telephone);
            }
        }

    }
</script>
